<template>
  <b-container>
    <config-publisher
      ref="configPublisher"
      v-model="config"
      tool-name="Stats and Standings Configuration"
      :config-name="configName"
      :can-edit="canStatsEdit"
      :can-publish="canStatsPublish"
      :is-form-valid="isFormValid">
      <b-card no-body>
        <b-tabs
          v-model="tabIndex"
          card>
          <b-tab
            v-if="config.stats"
            title="Stats">
            <stats-form
              ref="statsForm"
              v-model="config.stats" />
          </b-tab>
          <b-tab
            v-if="config.standings"
            title="Standings">
            <standings-form
              ref="standingsForm"
              v-model="config.standings" />
          </b-tab>
        </b-tabs>
      </b-card>
    </config-publisher>
  </b-container>
</template>

<script>
import ConfigPublisher from "@/components/ConfigPublisher"
import StatsForm from "@/components/Stats/StatsForm"
import StandingsForm from "@/components/Stats/StandingsForm"
import {mapGetters} from "vuex"

export default {
  name: "Stats",
  components: {
    StandingsForm,
    StatsForm,
    ConfigPublisher,
  },
  data: () => ({
    config: {},
    configName: "stats",
    tabIndex: 0,
  }),
  computed: {
    ...mapGetters([
      "canStatsEdit",
      "canStatsPublish",
    ]),
  },
  methods: {
    isFormValid() {
      const statsFormValid = this.$refs.statsForm.isValid()
      const standingsFormValid = this.$refs.standingsForm.isValid()
      return statsFormValid && standingsFormValid
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (this.$refs.configPublisher.configHasChanged()) {
      const message = `You have unpublished changes to your config, which will be lost.\n\nClick "Cancel" to go back and publish your work, or click "Yes" to lose your changes.`
      next(await this.$confirm.open(message))
    } else {
      next()
    }
  },
}
</script>

<style scoped>

</style>
